import { useI18n } from "../lib/i18n";
import { Languages } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuCheckboxItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { Button } from "./ui/button";

const LANGS = [
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
];

export default function LangSwitcher({ variant = "ghost", className = "" }) {
  const { lang, setLang, t } = useI18n();
  const active = LANGS.find((l) => l.code === lang) || LANGS[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant={variant}
          size="sm"
          className={`gap-1.5 px-2 ${className}`}
          data-testid="lang-switcher"
          aria-label={t("lang.label")}
        >
          <Languages className="h-4 w-4" />
          <span className="font-mono text-[11px] uppercase">{active.code}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[140px]">
        <DropdownMenuLabel className="text-[11px] uppercase tracking-wider text-muted-foreground">
          {t("lang.label")}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {LANGS.map((l) => (
          <DropdownMenuCheckboxItem
            key={l.code}
            checked={l.code === lang}
            onCheckedChange={() => setLang(l.code)}
            data-testid={`lang-option-${l.code}`}
          >
            {l.label}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
